import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const points = ['Querés darle lo mejor a tu perro', 'Pero no sabés por dónde empezar', 'Y te da miedo equivocarte con su alimentación'];
export function MicroValidation() {
  return <section className="pb-16 pt-2 px-4 bg-lightgreen" data-id="element-115">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.45
    }} className="max-w-lg mx-auto text-center" data-id="element-116">
        <div className="border border-primary/25 rounded-2xl px-8 py-10 md:px-10 md:py-12" data-id="element-117">
          <p className="text-sm font-semibold text-primary/70 uppercase tracking-wider mb-5" data-id="element-118">
            Si sentís que…
          </p>

          <div className="flex justify-center mb-6" data-id="element-119">
            <div className="space-y-3 inline-flex flex-col items-start" data-id="element-120">
              {points.map((point, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -8
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: 0.1 + index * 0.08
            }} className="flex items-center gap-3" data-id="element-121">
                  <CheckCircle2Icon className="w-5 h-5 text-primary flex-shrink-0" data-id="element-122" />
                  <span className="text-lg text-gray-700 text-left" data-id="element-123">
                    {point}
                  </span>
                </motion.div>)}
            </div>
          </div>

          <p className="text-xl md:text-2xl font-bold text-charcoal font-serif" data-id="element-124">
            Entonces esto es para vos.
          </p>
        </div>
      </motion.div>
    </section>;
}